import { render } from "./HTC.vue?vue&type=template&id=1037689a&scoped=true"
import script from "./HTC.vue?vue&type=script&lang=js"
export * from "./HTC.vue?vue&type=script&lang=js"

import "./HTC.vue?vue&type=style&index=0&id=1037689a&lang=scss&scoped=true"

import exportComponent from "E:\\Old Files\\Projecten Web\\Q-Mobile\\frame\\q-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1037689a"]])

export default __exports__